import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press11',
  templateUrl: './notice-press11.component.html',
  styleUrls: ['./notice-press11.component.scss']
})
export class NoticePress11Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
